<template>
  <div>
    <meta property="og:url"           content="https://www.your-domain.com/your-page.html" />
    <meta property="og:type"          content="website" />
    <meta property="og:title"         content="Your Website Title" />
    <meta property="og:description"   content="Your description" />
    <meta property="og:image"         content="https://www.your-domain.com/path/image.jpg" />
    <nav>
      <h4 v-if="path">{{path.translation.title}}</h4>
      <div class="right">
        <div class="distance-duration">
          <p class="distance">Distancia: {{Math.round(distance / 100) / 10}} Km</p>
          <p class="duration">Duração: {{Math.round(duration / 60)}} min</p>
        </div>
        <div class="action-buttons">
          <div @click="shareOpen = true" class="share">
            <img src="@/assets/share.svg">
          </div>
          <router-link to="/percursos" class="arrow">
            <img src="@/assets/close.svg" style="transform: rotate(-90deg);" >
          </router-link>
        </div>
      </div>
    </nav>
    <section class="content">
      <div id="map"></div>
      <div class="sidebar">
        <section class="interest-points">
          <div :class="[{'selected': interestPoint.id === selectedInterest}, [interestPoint.id]]" v-for="interestPoint in interestPoints" :key="interestPoint.id">
            <interestPoint :interestPoint="interestPoint" :description="true"/>
          </div>
        </section>
      </div>
    </section>
    <share-tab v-if="shareOpen" @close="shareOpen = false" :path="path"></share-tab>
  </div>
</template>
<script>

let image = require('@/assets/interest_point_marker.png')
import shareTab from '../components/share-tab'
let imageClick = require('@/assets/interest_point_marker_clicked.png')

export default {
  name: 'pontoDeInteresse',
  props: ['id'],
  components: {
    shareTab
  },
  data() {
    return {
      path: null,
      map: null,
      markers: [],
      clickedMarker: null,
      interestPoints: null,
      distance: 0,
      duration: 0,
      shareOpen: false,
      selectedInterest: null
    }
  },
  async mounted () {
    this.api.get('path/' + this.id + '/translated').then(path => {
      this.path = path
    })
    this.api.get('interestPoint?path=' + this.id ).then(points => {
      this.interestPoints = points
      setTimeout(() => this.loadMap(), 1)
    })

    const footer = document.body.querySelector('.apps');

    footer.style.marginTop = '-50px';
  },
  methods: {
    async loadMap () {
      try {
        var uluru = {lat: Number(38.8802201), lng: Number(-7.1627818)};
        let map = new google.maps.Map(document.getElementById('map'), {
          zoom: 15,
          center: uluru,
          mapTypeId: 'satellite',
          disableDefaultUI: true,
          scrollwheel: true,
          draggable: true
        })
        this.map = map
        this.addMarkers()
        this.calculateDirection(this.interestPoints)
      } catch (error) {
        console.error(error);
      }
    },
    calculateDirection (interestPoints) {
      var directionsService = new google.maps.DirectionsService;
        localStorage.removeItem('route-1')
      if (localStorage.getItem('route-1')) {
        let result = JSON.parse(localStorage.getItem('route'))
        this.drawLegs(result);
      } else {
        let waypoints = []
        interestPoints.forEach((point, key) => {
          if (key !== 0 && key !== interestPoints.length - 1) waypoints.push({location: point})
        })
        directionsService.route({
          origin: interestPoints[0],
          destination: interestPoints[interestPoints.length - 1],
          waypoints: [{location: interestPoints[1]}],
          travelMode: 'WALKING'
        }, (response) => {
          console.log(response)
            //localStorage.setItem('route-1', JSON.stringify(response))
            this.drawLegs(response);
        })
      }
    },
    drawLegs (result) {
      let modifiedResult, line, displayDirection
      for(var i = 0; i < result.routes[0].legs.length; i++){
        modifiedResult = JSON.parse(JSON.stringify(result))
        modifiedResult.request = result.request
        modifiedResult.geocoded_waypoints = []
        modifiedResult.geocoded_waypoints.push(result.geocoded_waypoints[i])
        modifiedResult.geocoded_waypoints.push(result.geocoded_waypoints[i+1])
        modifiedResult.routes[0].legs = [result.routes[0].legs[i]]

        this.distance += result.routes[0].legs[i].distance.value
        this.duration += result.routes[0].legs[i].duration.value

        line = {
          strokeColor: '#fff',
          strokeOpacity: 1,
          strokeWeight: 6
        }

        displayDirection = new google.maps.DirectionsRenderer({polylineOptions : line, suppressMarkers : true, preserveViewport : true})

        displayDirection.setMap(this.map)
        displayDirection.setDirections(modifiedResult)

        modifiedResult = null
      }
    },
    addMarkers () {
      this.markers.forEach(marker => {
        marker.setMap(null)
      })
      let interestPointsMarkers = []

      const infowindow = new google.maps.InfoWindow({
        content: null
      });

      this.interestPoints.forEach (point => {
        interestPointsMarkers.push(new google.maps.LatLng(point.lat, point.lng))
      })

      interestPointsMarkers.forEach(point => {
        let marker = new google.maps.Marker({
          position: point,
          icon: image,
          map: this.map,
          info: this.interestPoints.find(item => point.lat() === item.lat
           && point.lng() === item.lng)



        })
        marker.addListener('click', () => {
          marker.setIcon(imageClick)
          if (this.clickedMarker) this.clickedMarker.setIcon(image)
          this.clickedMarker = marker

          const element = document.body.getElementsByClassName(`${marker.info.id}`)[0]
          const documentSize = document.body.getBoundingClientRect()



          if(this.selectedInterest === marker.info.id) {
            return;
          }
          this.selectedInterest = marker.info.id

          if(documentSize.width > 600){
            window.scrollTo({
              top: element.getBoundingClientRect().top - documentSize.top - 140,
              behavior: 'smooth'
            })
          } else {
            const pointsCointainer = document.body.querySelector('.interest-points')

            pointsCointainer.scrollTo({
              left: element.offsetLeft,
              behavior: 'smooth'
            })
          }
        })
        marker.addListener('mouseover', () => {
          infowindow.setContent(
            `<div onclick="handleGoInterestPoint('${marker.info.id}')">` +
            `<h1 class="info-window-title">${marker.info.translation.title}</h1>` +
            `<p class="info-window-body">${marker.info.subtype}</p>` +
            '<div>' +
            "</div>" +
            "</div>"
          )
          marker.setIcon(imageClick)
          infowindow.open({
            anchor: marker,
            map: this.map,
            shouldFocus: false
          })
        })
        marker.addListener('mouseout', () => {
          marker.setIcon(image)
        })
        
        this.markers.push(marker)
      })
    },
    scrollEvent (e) {
      if (window.pageYOffset > window.innerHeight) {
        this.$el.querySelector('.filters').style.position = 'fixed'
      } else {
        this.$el.querySelector('.filters').style.position = 'relative'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
nav {
  height: 76px;
  background: #a79374;
  width: 100%;
  color: white;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1;
  h4 {
    font-size: 24px;
    font-weight: bold;
    margin-left: 40px;
    flex: 1;
  }
  p {
    font-weight: normal;
    font-size: 16px;
    margin-left: 40px;
  }

  .right {
    display: flex;
    align-items: center;

    @media (max-width: 550px){
      flex-direction: column-reverse;
    }
  }
  .action-buttons {
    display: flex;
  }
  .distance-duration {
    margin-left: auto;
    .distance {
      color: #eee3d4;
      font-weight: bold;
    }
    .duration {
      margin-top: 2px;
      color: #eee3d4;
    }
  }
  .share {
    margin-left: 30px;
    cursor: pointer;
  }
  .arrow {
    margin-left: 30px;
    margin-right: 30px;
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    img {
      display: block;
    }
  }

  @media (max-width: 550px){
    height: calc(152px - 24px - 24px);
    align-items: flex-start;
    padding: 24px 8px 24px 16px;
    width: calc(100% - 24px);

    h4 {
      font-size: 24px;
      margin-left: 0;
      font-weight: bold;
      line-height: normal;
    }

    p {
      margin-left: 0;
      color: #eee3d4;
    }

  .right {
    height: 100%;
    justify-content: flex-end;
  }

  .action-buttons {
    flex: 1;
  }

    .distance-duration {
      margin: 0;
      .distance {
        font-weight: bold;
        letter-spacing: -0.36px;
      }
      .duration {
        margin-top: 4px;
        display: block;

      }
    }
  }

}
.content {
  display: flex;
  position: relative;
  width: 100%;
  #map {
    width: 70%;
    margin: 0 0 0 0;
    height: calc(100vh - 76px);
    position: fixed!important;
    top: 76px;
  }
  .sidebar {
    background: #fff;
    width: 30%;
    margin-left: auto;
  }

  @media (max-width: 670px){
    flex-direction: column;
    #map {
      width: 100vw;
      min-height: 70vh;
      max-height: 70vh;
      position: relative !important;
      top: 0;

    }

    .sidebar { 
      width: 100vw;
      margin-left: 0;
      /* height: auto; */
      /* min-height: 300px; */
      overflow: hidden;
      padding: 0px;

      .interest-points {
        display: grid;
        grid-template-columns: repeat(2, 33%);
        grid-template-rows: repeat(1, 1fr);
        grid-auto-columns: 33%;
        grid-auto-flow: column;
        overflow-y: scroll;
        margin-top: 8px;
        padding: 8px 12px;
      }
    }
  }
}


.interest-points div {
  &:first-of-type {
    margin-top: 40px;
  }
  &:last-of-type {
    margin-bottom: 40px;
  }

  @media (max-width: 670px){
    &:first-of-type {
      margin-top: 4px;
    }
  }
}
.interest-points /deep/ .interest-point-item {
  position: relative;
  padding: 20px 40px 20px 40px;
  width: calc(100% - 80px);
  display: block;
  & > .image {
    max-height: 200px;
    display: block;
    img {
      width: 100%;
    }

    @media (max-width: 670px){
      max-height: 400px;
    }
  }
  h2 {
    font-weight: bold;
    font-size: 18px;
    line-height: 1.22;
    letter-spacing: -0.4px;
    color: #a79374;
    margin-top: 16px;
  }
  p.subtype {
    color: #a79374;
    font-size: 18px;
    line-height: 1.56;
    letter-spacing: -0.4px;
  }
  p {
    font-size: 18px;
    line-height: 1.56;
    letter-spacing: -0.4px;
  }
  @media (max-width: 1000px){
    padding: 20px 8px 20px 12px;
    width: calc(100% - 20px);
  }

   @media (max-width: 670px){
    padding: 20px 16px 20px 16px;
    width: calc(100% - 32px);

    p:not(.subtye){
      display: none;
    }
  }
}
.selected /deep/ .interest-point-item {
  .title, p.subtype {
    color: #f6b92f;
  }
}
</style>